module.exports = __webpack_public_path__ + "img/honer2.b07caa67.jpg";